"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SilentAuthContext = void 0;
var _react = require("react");
var _SilentAuthModel = require("../models/SilentAuthModel");
var stub = function stub() {
  throw new Error('<SilentAuthProvider> not found.');
};
var SilentAuthContext = (0, _react.createContext)({
  authStatus: _SilentAuthModel.EAuthStatus.Idle,
  initiateAuth: stub,
  verifySmsCode: stub
});
exports.SilentAuthContext = SilentAuthContext;
SilentAuthContext.displayName = 'SilentAuthContext';